import React, { useEffect } from "react";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ThankYouPage = () => {
  const navigate = useNavigate();
  const CheckoutData = useSelector((state) => state.checkout?.CheckoutData);

  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src = "https://www.googletagmanager.com/gtag/js?id=AW-16647750621";
    script1.async = true;
    document.head.appendChild(script1);

    script1.onload = () => {
      const script2 = document.createElement("script");
      script2.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-16647750621');
        `;
      document.head.appendChild(script2);
    };

    return () => {
      const scripts = document.querySelectorAll(
        'script[src="https://www.googletagmanager.com/gtag/js?id=AW-16647750621"]'
      );
      scripts.forEach((script) => script.remove());
    };
  }, []);

  console.log(
    "CheckoutData?.order?.totalPrice?.toFixed(2)",
    CheckoutData?.order?.totalPrice?.toFixed(2)
  );

  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-16647750621/zBwdCKHYjcEaEN2HooI-",
        value: CheckoutData?.order?.totalPrice?.toFixed(2),
        currency: "INR",
        transaction_id: "",
      });
    }
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-blue-50 to-blue-100 px-4">
      <div className="bg-white shadow-xl rounded-2xl p-8 max-w-lg text-center">
        <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto animate-bounce" />
        <h2 className="text-3xl font-bold text-gray-800 mt-4">
          Thank You for Your Order!
        </h2>

        <p className="text-gray-600 mt-3">
          Your order has been successfully placed. We're getting it ready for
          shipment!
        </p>

        <p className="text-gray-600 mt-3 font-medium">
          You will receive a confirmation email shortly with your order details
          and tracking information once it ships.
        </p>

        <p className="text-gray-500 mt-3">
          Please check your registered email for updates on your order status.
        </p>
        <p className="text-blue-600 font-bold">
          To track your order, download the app from the link below:
        </p>

        <div className="mt-6 flex flex-col gap-4">
          <a
            href="https://play.google.com/store/apps/details?id=com.bharatcod"
            className="bg-orange-600 text-white px-6 py-3 rounded-lg shadow-md hover:bg-orange-700 transition font-medium"
          >
            Download the App
          </a>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
